import dayjs from 'dayjs';
import { isNullish } from 'libs/utils';
export const mediaHasVideo = (mediaInfo) => (mediaInfo !== null && mediaInfo.hasVideo);
export const mediaIsPackaged = (project) => (
// NOTE: This logic would be better, but we cannot use it, because
// backend sometimes fills wrong value in isPackaged.
// mediaInfo !== null && mediaInfo.isPackaged
project.recordingId !== null);
export const mediaIsStreaming = (project) => (project.indexFileId !== null);
export const createKeywordsFromApi = (textList) => {
    return textList.map((innerList) => innerList
        .map((keyword) => (Object.assign(Object.assign({}, keyword), { category: keyword.category === null ? undefined : keyword.category, highlight: keyword.highlight === null ? undefined : keyword.highlight, timestampSec: isNullish(keyword.timestampMs) ? undefined : keyword.timestampMs / 1000, type: keyword.type === undefined ? 'phrase' : keyword.type }))));
};
export const createProjectFromApi = (apiProject) => {
    var _a, _b;
    const start = apiProject.description.start === null ? null : dayjs(apiProject.description.start);
    const keywordsHighlight = createKeywordsFromApi((_b = (_a = apiProject.keywordsHighlight) === null || _a === void 0 ? void 0 : _a.textList) !== null && _b !== void 0 ? _b : []);
    if (apiProject.transcriptionConfig === null) {
        return Object.assign(Object.assign({}, apiProject), { start,
            keywordsHighlight, transcriptionConfig: null });
    }
    return Object.assign(Object.assign({}, apiProject), { start,
        keywordsHighlight, transcriptionConfig: Object.assign({}, apiProject.transcriptionConfig) });
};
